<template>
  <div>
    <v-row style="width: 100%">
      <v-col cols="12" class="mt-5 text-center">
        <h3>개발용 테스트 페이지</h3>
      </v-col>
    </v-row>

    <!-- 샘플개발중 -->
    <v-row class="d-flex flex-column align-center" style="width: 100%">
      <v-col class="text-center">
        <v-btn color="primary" @click="toMain()">메인으로🏃🏻‍➡️</v-btn>
      </v-col>
      <v-col class="text-center">
        <v-btn color="primary" @click="toApplMenuList()"
          >신청서 메뉴로🏃🏻‍➡️</v-btn
        >
      </v-col>
      <v-col class="text-center">
        <v-btn color="primary" @click="clickPeriodPicker()">기간선택📅</v-btn>
      </v-col>
      <v-col class="text-center">
        <v-btn color="primary" @click="clickTimePicker()">시간선택⏰</v-btn>
      </v-col>
      <v-col class="text-center">
        <v-btn color="primary" @click="openLocationCheckDialog()">
          위치체크🗺️
        </v-btn>
      </v-col>
    </v-row>

    <!-- import component area -->
    <select-period-dialog
      :minDate="'20260304'"
      :maxDate="'20260315'"
      @applySelectedPeriod="applySelectedPeriod"
    ></select-period-dialog>

    <bottom-time-double-picker
      :flag="timePickerFlag"
      :customLabel="{ rangePrefix: '근무', tabPrefix: '근무' }"
      :startTime="'10:36'"
      @applySelectedTime="applySelectedTime"
    ></bottom-time-double-picker>

    <!-- 현재위치체크 모달 -->
    <location-check-dialog @saveTimecardReq="nothing()" :isIn="true">
    </location-check-dialog>
  </div>
</template>

<script>
/* 개발 디자인적용 테스트용 페이지 */
import SelectPeriodDialog from '@/components/common/dialog/SelectPeriodDialog.vue';
import BottomTimeDoublePicker from '@/components/common/BottomTimeDoublePicker.vue';
import LocationCheckDialog from '@/components/main/dialog/LocationCheckDialog.vue';

export default {
  data: () => ({
    timePickerFlag: false, // 시작시간 선택 플래그
  }),

  methods: {
    toMain() {
      this.$router.push('/main');
    },
    toApplMenuList() {
      this.$router.push('/applicationMenu');
    },

    /* 기간선택 모달에서 선택한 기간값 받는 메서드 */
    applySelectedPeriod({ sdate, edate }) {
      console.log('선택된 기간:', sdate, edate);
    },

    applySelectedTime({ startTime, endTime }) {
      alert(`선택된 시간: ${startTime} : ${endTime}`);
    },

    clickPeriodPicker() {
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'select_period');
    },

    clickTimePicker() {
      this.timePickerFlag = !this.timePickerFlag;
    },

    /* 지도모달 오픈 */
    openLocationCheckDialog() {
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'location_check');
    },

    nothing() {
      // pass
    },
  },

  components: {
    SelectPeriodDialog,
    BottomTimeDoublePicker,
    LocationCheckDialog,
  },
};
</script>

<style lang="scss" scoped></style>
